import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type { IDocumentType } from "@/types/(company)/documentTypes.interface";
import { createApi } from "@reduxjs/toolkit/query/react";

interface DocumentTypesResponse {
  data: IDocumentType[];
  meta: { total: number; page: number; lastPage: number; limit: number };
}

interface DocumentTypesParams {
  limit?: number;
  page?: number;
  search?: string;
  category?: string;
}

export const myspaceDocumentTypesApi = createApi({
  reducerPath: "myspaceDocumentTypesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["MyspaceDocumentTypes"],
  endpoints: (builder) => ({
    getMyspaceDocumentTypes: builder.query<DocumentTypesResponse, DocumentTypesParams | void>({
      query: (params) => ({
        url: "/employee/document-types",
        params: { limit: 100, ...params },
      }),
      providesTags: ["MyspaceDocumentTypes"],
    }),
  }),
});

export const { useGetMyspaceDocumentTypesQuery } = myspaceDocumentTypesApi;
